import React from "react";
import styles from "./styles.module.css";

export const FullSize = ({ children }: { children?: React.ReactNode }) => (
  <div className={styles.component}>{children}</div>
);
